import { DEPTH_TOLERANCE } from './constants';

/** Floating-point slack on a depth comparison: (119 - 107.1) / 119 is 0.10000000000000005 in binary floating point, and one öre on a 10 000 kr price is 1e-6. */
const DEPTH_EPSILON = 1e-9;

/** True when `depth` strictly exceeds `threshold`, allowing the floating-point slack of a depth comparison. */
export function exceedsDepth(depth: number, threshold: number): boolean {
  return depth > threshold + DEPTH_EPSILON;
}

/** True when two depths lie within DEPTH_TOLERANCE of each other (CONTEXT.md, Campaign run). */
export function withinDepthTolerance(a: number, b: number): boolean {
  return Math.abs(a - b) <= DEPTH_TOLERANCE + DEPTH_EPSILON;
}

/** True when `price` reaches `floor`, a price derived from a depth, allowing the floating-point slack of a depth comparison. */
export function priceReachesFloor(price: number, floor: number): boolean {
  return price >= floor * (1 - DEPTH_EPSILON);
}
